// extracted by mini-css-extract-plugin
module.exports = {"root":"CitySelect_root__l9XnY","label":"CitySelect_label__dov_r","options":"CitySelect_options__dKlU3","opened":"CitySelect_opened__tNlyu"};